import { Link, useNavigate } from "react-router-dom"
import "../styles/Footer.css"
import logo from "../assets/images/haroSilver.png"
import whatsapp from "../assets/images/whatsapp.webp"

// import logo ""

function Footer() {
  const navigate = useNavigate();

  const handleWhatsAppRedirect = () => {
    const phoneNumber = '917019272992';
    const message = "Hi, I'm interested in purchasing your products. Could you please share more details?"
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank'); // Opens WhatsApp in new tab
  };
  const goToSectionProductFooter = () => {
    navigate('/', { state: { scrollToId: 'productFilter' } });
  };



  const goToSectionHome = () => {
    navigate('/', { state: { scrollToId: 'homeBannerHaro' } });
  };

    const gallerySection = () => {
    navigate('/', { state: { scrollToId: 'gallerysection' } });

  };
  return (
    <>
      <div className="whatsappContainer" onClick={handleWhatsAppRedirect}>
        <img src={whatsapp} alt="whatsapp" />
      </div>

      <footer className="footer-section">
        <div>
          <div className="row">

            <div className="col-lg-4 col-md-6 footer-col">
              <div className="footer-logo">
                <img src={logo} alt="logo" />
              </div>

              <div className="footercontentbottom">
                <p>Haronics offers pure, chemical-free cold pressed oils using traditional methods. We focus on wellness, sustainability, and ethical sourcing.</p>
              </div>
              <div className="footer-social">
                <a href="https://www.facebook.com/share/1GDB5NKRGB/?mibextid=qi2Omg" target="_blank" className="footer-social-link"><i className="fab fa-facebook-f"></i></a>
                {/* <a href="#" className="footer-social-link"><i className="fab fa-twitter"></i></a> */}
                <a href="https://www.instagram.com/haronicsindia?igsh=YXdnY2l2cDVtd240" target="_blank" className="footer-social-link"><i className="fab fa-instagram"></i></a>
                <a href="https://www.linkedin.com/company/haronicscp/" target="_blank" className="footer-social-link"><i className="fab fa-linkedin-in"></i></a>
                <a href="https://www.youtube.com/@haronicsconsumerproductsll72?si=WCEXMtkCmOOaguZv" target="_blank" className="footer-social-link"><i className="fab fa-youtube"></i></a>
              </div>
            </div>

            <div className="col-lg-2 col-md-6 footer-col">
              <h4 className="footer-title">Quick Links</h4>
              <ul className="footer-links">
                <li><a onClick={goToSectionHome}><i className="fas fa-chevron-right"></i> Home</a></li>
                <li><Link to="/about-us"><i className="fas fa-chevron-right"></i> About Us</Link></li>
                <li><a onClick={goToSectionProductFooter}><i className="fas fa-chevron-right"></i> Products</a></li>
                <li><Link to="/contact-us"><i className="fas fa-chevron-right"></i> Contact</Link></li>
                <li><a onClick={gallerySection}><i className="fas fa-chevron-right"></i> Gallery</a></li>
              </ul>
            </div>

            <div className="col-lg-3 col-md-6 footer-col">
              <h4 className="footer-title">Our Products</h4>
              <ul className="footer-links">

                <li><a onClick={goToSectionProductFooter}><i className="fas fa-chevron-right"></i>Oils</a></li>
                <li><a onClick={goToSectionProductFooter}><i className="fas fa-chevron-right"></i>Ghee</a></li>
                <li><a onClick={goToSectionProductFooter}><i className="fas fa-chevron-right"></i> Peanut Butter</a></li>
                <li><a onClick={goToSectionProductFooter}><i className="fas fa-chevron-right"></i> Jaggery</a></li>

                <li><a onClick={goToSectionProductFooter}><i className="fas fa-chevron-right"></i> Honey</a></li>
                <li><a onClick={goToSectionProductFooter}><i className="fas fa-chevron-right"></i> Butter</a></li>
              </ul>
            </div>

            <div className="col-lg-3 col-md-6 footer-col">
              <h4 className="footer-title">Contact Us</h4>
              <div className="footer-contact-item">
                <div className="footer-contact-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div className="footer-contact-text">
                  Haronics Consumer Products LLP <br></br>Sy No 62/4 Bendiganahalli, Bidarahalli Hobli Bengaluru Karnataka 560049
                </div>
              </div>
              <div className="footer-contact-item">
                <div className="footer-contact-icon">
                  <i className="fas fa-phone-alt"></i>
                </div>
                <div className="footer-contact-text">
                  70192 72992 <br></br>

                </div>
              </div>
              <div className="footer-contact-item">
                <div className="footer-contact-icon">
                  <i className="fas fa-envelope"></i>
                </div>
                <div className="footer-contact-text">
                  haronicsindia@gmail.com <br></br>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <p className="footer-bottom-text">© 2025 Haronics. All Rights Reserved.</p>
            <div className="footer-bottom-links">
              <Link to='/privacy-policy'>Privacy Policy</Link>
              <Link to='/terms and conditions'>Terms and Conditions</Link>
            </div>
            <div className="roshanscapeDev">
              <a href="https://roshanscape.in/" target="_blank">© Developed By RoshanScape</a>
            </div>
          </div>
        </div>
      </footer>

    </>

  )
}

export default Footer
